import { CollaborationResult, ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import { ClassifierDto } from '@/application/interfaces/pegasus.gateway';

import { INFRASTRUCTURE_ERROR_IDENTIFIER } from '../interfaces/infrastructure-error';
import type { IPegasusGateway } from '../interfaces/pegasus.gateway';

@injectable()
export class GetHighestClassificationLevelsCollaboration
  implements ICollaboration<string, CollaborationResult<ClassifierDto>>
{
  constructor(
    @inject('IPegasusStudyPlanGateway')
    private readonly pegasusIOGateway: IPegasusGateway,
  ) {}

  public async run(): Promise<CollaborationResult<ClassifierDto[]>> {
    const data = await this.pegasusIOGateway.getHighestClassificationLevels();

    if (data?.identifier === INFRASTRUCTURE_ERROR_IDENTIFIER) {
      throw new Error(INFRASTRUCTURE_ERROR_IDENTIFIER);
    }
    return data;
  }
}
